import { useState } from "react";
import { FAQS } from "./trainingData";

export default function FaqSection() {
  const [openFaq, setOpenFaq] = useState([]);

  const toggleFaq = (i) => {
    setOpenFaq((prev) =>
      prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]
    );
  };

  return (
    <section id="faq" className="max-w-[900px] mx-auto px-4 py-12 sm:px-6 md:px-10 sm:py-22">
      <div
        className="font-mono text-[12px] text-[#71717a] mb-[18px]"
        style={{ letterSpacing: "0.18em" }}
      >
        10 — QUESTIONS
      </div>
      <h2
        className="font-bold text-white mb-10"
        style={{
          fontSize: "clamp(30px, 3.5vw, 44px)",
          lineHeight: 1.06,
          letterSpacing: "-0.03em",
        }}
      >
        Before you enroll
      </h2>
      <div className="border-t border-[#27272a]">
        {FAQS.map((faq, i) => {
          const isOpen = openFaq.includes(i);
          return (
            <div key={i} className="border-b border-[#27272a]">
              <button
                type="button"
                onClick={() => toggleFaq(i)}
                className="w-full bg-transparent border-0 py-6 flex gap-5 items-center cursor-pointer font-[inherit] text-left text-white"
              >
                <span className="flex-1 text-[18px] font-semibold tracking-[-0.01em]">
                  {faq.q}
                </span>
                <span className="font-mono text-[20px] w-6 text-center" style={{ color: isOpen ? "#a3e635" : "#71717a" }}>
                  {isOpen ? "–" : "+"}
                </span>
              </button>
              {isOpen && (
                <div className="text-[16px] leading-[1.7] text-[#a1a1aa] pb-[26px] max-w-[720px] pr-4 sm:pr-16">
                  {faq.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
